import React from 'react';
import { OptForm } from '../components';

import { FaqsContainer } from "../containers/faqs";
import { FooterContainer } from "../containers/footer";
import { HeaderContainer } from '../containers/header';
import { JumbotronContainer } from "../containers/jumbotron";
import { Feature } from '../components';

export default function Home() {
 return( <>
    <HeaderContainer>
      <Feature>
        <Feature.Title>
          Films, TV programmes and all things media
        </Feature.Title>
        <Feature.SubTitle>
        Accessible from anywhere, use it on mobile when on the go or from your laptop/TV when at home on the couch!        </Feature.SubTitle>
        <OptForm.Text>Ready to watch? Enter your email to request access, or sign in with an existing account</OptForm.Text>     

        <OptForm>
        <OptForm.Input placeholder="Email address" />
              <OptForm.Button>Try It Now!</OptForm.Button>

        </OptForm>


        </Feature>
      
      </HeaderContainer>
      <JumbotronContainer/>
      {/* <FaqsContainer/> */}
      <FooterContainer/>
  </>  
 )  
}